import Card from '../card/card'

class CollectionCard extends Card {
  connectedCallback(): void {}
}

export default CollectionCard
